<!--
 * @Description: 设备报修统计
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2022-11-24 15:07:01
 * @LastEditTime: 2022-11-24 16:37:09
-->
<template>
<div class="statisticalChartsContainer">
  <!-- 设备报修统计 -->
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox" :id="idName">
        <echarts :chart-id="idName" :chart-option="options"></echarts>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    // flag: {
    //   type: Boolean,
    //   default: false
    // },
  },
  data() {
    return {
      total: 0,
      options: {
        tooltip: {
          trigger: 'item',
          confine: true
        },
        series: [
          {
            type: 'pie',
            radius: [0, '40%'],
            label: {
              position: 'inner',
              fontSize: 10,
              color: '#fff'
            },
            data: [
              {
                value: 0,
                name: '维修中',
                itemStyle: {
                    normal: {//颜色渐变
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#FF7116'},
                                {offset: 1, color: '#FFAF4B'},
                            ]
                        )
                    }
                }
              },
              {
                value: 0,
                name: '已维修',
                itemStyle: {
                    normal: {//颜色渐变
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#0058BD'},
                                {offset: 1, color: '#3492FF'},
                            ]
                        )
                    }
                }
              }
            ]
          },
          {
            type: 'pie',
            radius: ['50%', '62%'],
            color: ['#FF2586', '#AD4CFF', '#15D6DA', '#6EFB3A', '#FDE808', '#FE9E1B'],
            labelLine: {
              length: 30
            },
            label: {
              formatter: '{b|{b}} \n {per|{d}%}',
              rich: {
                b: {
                  color: '#fff',
                  fontSize: 12,
                  lineHeight: 20
                },
                per: {
                  color: '#03D1F8'
                }
              }
            },
            data: [
              { value: 0, name: '低电量' },
              { value: 0, name: '灰尘' },
              { value: 0, name: '维修' },
              { value: 0, name: '维保' },
              { value: 0, name: '监测' },
              { value: 0, name: '其他' }
            ]
          }
        ]
      }
    }
  },
  created() {
    this.getEchartsList()
  },
  computed: {
    idName() {
      // return this.flag ? "echartsId10_big" : "echartsId10"
      return "echartsId10"
    }
  },
  mounted() {},
  methods: {
    initStyle() {
      this.options.series[0].radius = this.styleObj.radius
      this.options.series[0].itemStyle.normal.labelLine.length = this.styleObj.length
      this.options.series[0].itemStyle.normal.labelLine.length2 = this.styleObj.length2
      this.options.series[0].itemStyle.normal.label.fontSize = this.styleObj.labelFontsize
      this.options.title.textStyle.fontSize = this.styleObj.fontSize
      this.options.graphic.elements[0].style.width = this.styleObj.graphic.width
      this.options.graphic.elements[0].style.height = this.styleObj.graphic.height
    },
    async getEchartsList() {//设备分类
      const { data, msg, code } = await this.request.post('/front/device/repair/repairStatistics')
      if (code != 200) return
      let options = JSON.parse(JSON.stringify(this.options))
      let { repairTylelist, repairlist } = data

      let seriesData = []
      for (let [name, value] of Object.entries(repairTylelist)) {
        seriesData.push({ name, value})
      }

      options.series[0].data[0].value = repairlist['维修中']
      options.series[0].data[1].value = repairlist['已维修']
      options.series[1].data = seriesData

      this.options = options
    }
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;  

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;
      position: relative;
      background: url('../../assets/img/bigScreen/bid-circle.png') no-repeat center;
      background-size: 45%;
      animation: rotate 2s 2s 0 infinite normal;
      will-change: transform;
      transform: translateZ(0);
      h4 {
        position: absolute;
        top: 45%;
        left: 50%;
        color: #fff;
        font-size: 16px;
        width: 70px;
        margin-left: -35px;
        overflow: hidden;
        font-family: 'PMZD';
        color: #02D9FD;
      }

      .chartBox {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@keyframes rotate {
  0% { transform: rotateZ(0deg) }
  100% { transform: rotateZ(360deg) }
}
</style>
